var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHistory = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 2048 2048"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1110.8 531.7h-119v483.7H653.9v119h456.9z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M1796.5 1021.5v-.8C1796 594.4 1450.3 249 1024 249c-426.6 0-772.5 345.8-772.5 772.5S597.3 1794 1024 1794v-169c-333.8 0-604.4-270.6-604.4-604.4S690.2 416.3 1024 416.3s604.4 270.6 604.4 604.4v.8h-188.9l271.3 272.4 271.3-272.4z"
})));
export default SvgHistory;